var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turma",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "turmaId",
      "items": _vm.turmas,
      "return-object": "",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "change": _vm.onTurmaChage
    },
    model: {
      value: _vm.content.turma,
      callback: function ($$v) {
        _vm.$set(_vm.content, "turma", $$v);
      },
      expression: "content.turma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataRealizacao", $$v);
      },
      expression: "content.dataRealizacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Turno",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.nomeTurno,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeTurno", $$v);
      },
      expression: "content.nomeTurno"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hora",
      "outlined": "",
      "dense": "",
      "maxLength": "5",
      "rules": [function (h) {
        return _vm.horaValida(h);
      }, function (h) {
        return _vm.validarFormatoHora(h) || 'O horário deve ser no formato HH:MM';
      }],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": function ($event) {
        return _vm.formatarHoraInput('hora', $event);
      }
    },
    model: {
      value: _vm.content.hora,
      callback: function ($$v) {
        _vm.$set(_vm.content, "hora", $$v);
      },
      expression: "content.hora"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atividade",
      "outlined": "",
      "dense": "",
      "maxlength": "200",
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.atividade,
      callback: function ($$v) {
        _vm.$set(_vm.content, "atividade", $$v);
      },
      expression: "content.atividade"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Instrutores",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "instrutorId",
      "items": _vm.instrutores,
      "return-object": "",
      "disabled": _vm.camposDesabilitados,
      "multiple": ""
    },
    model: {
      value: _vm.content.instrutor,
      callback: function ($$v) {
        _vm.$set(_vm.content, "instrutor", $$v);
      },
      expression: "content.instrutor"
    }
  })], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.podeAdicionarProgramacao || _vm.isViewMode || _vm.situacaoEmRevisao
    },
    on: {
      "click": _vm.adicionarAtualizarProgramacao
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Incluir ")], 1)], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "items": _vm.content.programacoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.turma`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.turma.nome) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.dataRealizacao) + " ")];
      }
    }, {
      key: `item.hora`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.formatarHora(item.hora)) + " ")];
      }
    }, {
      key: `item.atividade`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.atividade) + " ")];
      }
    }, {
      key: `item.instrutor`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s((Array.isArray(item.instrutor) ? item.instrutor : [item.instrutor]).map(function (instrutor) {
          return instrutor.nome;
        }).join(', ')) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item,
          index = _ref6.index;
        return [_c('div', {
          key: index
        }, [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.editarProgramacao(item, index);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.excluirProgramacao(item, index);
            }
          }
        })], 1)];
      }
    }], null, true)
  }), (_vm.$user.isAdmGre || _vm.$user.isAdmGeral) && _vm.qtdAjustes >= 3 && !_vm.isViewMode ? _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.")])], 1) : _vm._e(), _vm.situacaoParaExibirComentario ? _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Comentário",
      "maxlength": "400",
      "counter": "400",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "disabled": _vm.isViewMode || _vm.qtdAjustes >= 3 || _vm.isReenviar()
    },
    model: {
      value: _vm.content.comentario,
      callback: function ($$v) {
        _vm.$set(_vm.content, "comentario", $$v);
      },
      expression: "content.comentario"
    }
  })], 1)], 1) : _vm._e(), !_vm.isFormador ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.content.ultimaAtualizacao))])])])], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-block text-center btn-group"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.voltar
    }
  }, [_vm._v(" Voltar ")]), !_vm.isViewMode && _vm.isFormador ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar(false);
      }
    }
  }, [_vm._v(" Salvar ")]) : _vm._e(), !_vm.isViewMode && _vm.isFormador && !_vm.situacaoParaExibirComentario ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar(true);
      }
    }
  }, [_vm.actionIcon ? _c('v-icon', [_vm._v(_vm._s(_vm.actionIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.edit ? 'Editar e Avançar' : 'Salvar e Avançar') + " ")], 1) : _vm._e(), _vm.isFormadorOrAdm && !_vm.isViewMode && _vm.situacaoParaExibirComentario ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.solicitarCorrecao
    }
  }, [_vm._v(" Salvar e Avançar ")]) : _vm._e(), !_vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" " + _vm._s(_vm.isReenviar() ? 'Cancelar' : 'Fechar') + " ")]) : _vm._e(), _vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.avancar
    }
  }, [_vm._v(" Avançar ")]) : _vm._e(), (_vm.isFormadorOrAdm || _vm.isReenviar()) && !_vm.situacaoParaNaoExibirBaixar ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.baixarProgramacao
    }
  }, [_vm._v("Baixar Programação")]) : _vm._e(), _vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" Fechar ")]) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }